import * as Redux from 'redux';
import { IActionCreator } from '../../../interfaces/IActionCreator';
import { Keys } from './types';

export interface INotificationActions {
    setSaveNotification: (value: customNotification) => void;
}

export const notifActionCreator: IActionCreator<INotificationActions> = (dispatch: Redux.Dispatch<any>): INotificationActions => {
    return {
        setSaveNotification: (value: customNotification) => {
            dispatch({
                type: Keys.SHOWNOTIFICATION,
                payload: value
            })
        },
    }
}